import { useEffect, useRef, useState } from "react";
import type { ReactNode } from "react";

export function PrimaryBtn(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button {...props} className={`rounded-md bg-primary px-3 py-2 text-sm font-medium text-primary-foreground disabled:opacity-60 ${props.className ?? ""}`} />;
}

export function GhostBtn(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button {...props} className={`rounded-md border border-border bg-card px-3 py-2 text-sm hover:bg-muted disabled:opacity-60 ${props.className ?? ""}`} />;
}

export function ConfirmBtn({
  children, onConfirm, message = "Xác nhận?", className, title,
  timeoutMs = 10000, disabled,
}: {
  children: ReactNode;
  onConfirm: () => void;
  message?: string;
  className?: string;
  title?: string;
  timeoutMs?: number;
  disabled?: boolean;
}) {
  const [armed, setArmed] = useState(false);
  const [left, setLeft] = useState(Math.ceil(timeoutMs / 1000));
  const timer = useRef<number | null>(null);
  const tick = useRef<number | null>(null);
  useEffect(() => () => {
    if (timer.current) window.clearTimeout(timer.current);
    if (tick.current) window.clearInterval(tick.current);
  }, []);
  function arm(e: React.MouseEvent) {
    e.stopPropagation();
    if (disabled) return;
    setArmed(true);
    setLeft(Math.ceil(timeoutMs / 1000));
    if (timer.current) window.clearTimeout(timer.current);
    if (tick.current) window.clearInterval(tick.current);
    timer.current = window.setTimeout(() => setArmed(false), timeoutMs);
    tick.current = window.setInterval(() => setLeft((n) => (n > 0 ? n - 1 : 0)), 1000);
  }
  function cancel(e: React.MouseEvent) {
    e.stopPropagation();
    setArmed(false);
    if (timer.current) window.clearTimeout(timer.current);
    if (tick.current) window.clearInterval(tick.current);
  }
  function confirm(e: React.MouseEvent) {
    e.stopPropagation();
    setArmed(false);
    if (timer.current) window.clearTimeout(timer.current);
    if (tick.current) window.clearInterval(tick.current);
    onConfirm();
  }
  if (!armed) {
    return (
      <button type="button" title={title} disabled={disabled} onClick={arm}
        className={`rounded-md border border-destructive/50 px-3 py-2 text-sm text-destructive hover:bg-destructive/10 disabled:opacity-60 ${className ?? ""}`}>
        {children}
      </button>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 rounded-md border border-destructive/60 bg-destructive/5 px-1.5 py-1 text-xs">
      <span className="px-1 text-destructive whitespace-nowrap">{message} ({left}s)</span>
      <button type="button" onClick={confirm}
        className="rounded bg-destructive px-2 py-0.5 text-destructive-foreground hover:opacity-90">Xoá</button>
      <button type="button" onClick={cancel}
        className="rounded border border-border px-2 py-0.5 hover:bg-muted">Huỷ</button>
    </span>
  );
}
